import { StandardProps } from "@/components/componentMap";
import styles from "./StoryPlaceholder.module.scss";

export function StoryPlaceholder({
  configProps,
}: Pick<StandardProps, "configProps">) {
  return (
    <div
      className={styles.placeholder}
      data-component="StoryPlaceholder"
      style={{
        height: (configProps?.height as number) || 40,
      }}
    >
      {(configProps?.label as string) || "Slot"}
    </div>
  );
}
